import { createApiCallActions } from 'src/app/common/store/generic.actions';
import {
  GroupedLabelWithValue,
  LabelWithValue,
  MarketingPerformanceReportItem,
  Period,
  SalesPerformanceFacetItem,
  SalesPerformanceReportItem,
  CallsPerformanceReportItem,
} from './types';
import { createAction, props } from '@ngrx/store';

export const reportingActions = {
  getReportByFilter: createApiCallActions<any[]>(
    'reporting',
    'getReportByFilter',
  ),
  setBarGraphStartDate: createAction(
    '[Reporting] Set bar graph start date',
    props<{ barGraphStartDate: string }>(),
  ),
  setBarGraphEndDate: createAction(
    '[Reporting] Set bar graph start date',
    props<{ barGraphEndDate: string }>(),
  ),

  getReportMalePeopleByAge: createApiCallActions<any[]>(
    'reporting',
    'getReportMalePeopleByAge',
  ),
  getReportFemalePeopleByAge: createApiCallActions<any[]>(
    'reporting',
    'getReportFemalePeopleByAge',
  ),

  getLeadsByDayAndHoursRange: createApiCallActions<any[]>(
    'reporting',
    'getLeadsByDayAndHoursRange',
  ),
  getReportPeopleByRegime: createApiCallActions<any[]>(
    'reporting',
    'getReportPeopleByRegime',
  ),
  getReportLeadsByCity: createApiCallActions<any[]>(
    'reporting',
    'getReportLeadsByCity',
  ),
  getPeriods: createApiCallActions<Period[]>('reporting', 'getPeriods'),

  getLeadCount: createApiCallActions<number>('reporting', 'getLeadCount'),
  getConversionRateCount: createApiCallActions<number>(
    'reporting',
    'getConversionRateCount',
  ),
  getRawContractCount: createApiCallActions<number>(
    'reporting',
    'getRawContractCount',
  ),
  getValidatedContractCount: createApiCallActions<number>(
    'reporting',
    'getValidatedContractCount',
  ),
  getReportLeadsByCategory: createApiCallActions<any[]>(
    'reporting',
    'getReportLeadsByCategory',
  ),
  getReportContractsByProductCategory: createApiCallActions<any[]>(
    'reporting',
    'getReportContractsByProductCategory',
  ),
  getReportLeadsBySource: createApiCallActions<any[]>(
    'reporting',
    'getReportLeadsBySource',
  ),
  getReportContractsBySource: createApiCallActions<any[]>(
    'reporting',
    'getReportContractsBySource',
  ),
  getReportLeadsBySalesPerson: createApiCallActions<any[]>(
    'reporting',
    'getReportLeadsBySalesPerson',
  ),
  getReportContractsBySalesPerson: createApiCallActions<any[]>(
    'reporting',
    'getReportContractsBySalesPerson',
  ),
  getReportMonthlyProgress: createApiCallActions<GroupedLabelWithValue[]>(
    'reporting',
    'getReportMonthlyProgress',
  ),
  getReportSalesTotalAndObjectives: createApiCallActions<
    GroupedLabelWithValue[]
  >('reporting', 'getReportSalesTotalAndObjectives'),
  getSalesPerformance: createApiCallActions<SalesPerformanceReportItem[]>(
    'reporting',
    'getSalesPerformance',
  ),
  getSalesPerformanceFacetItems: createApiCallActions<
    SalesPerformanceFacetItem[]
  >('reporting', 'getSalesPerformanceFacetItems'),
  getCallsPerformance: createApiCallActions<CallsPerformanceReportItem[]>(
    'reporting',
    'getCallsPerformance',
  ),
  getMarketingPerformance: createApiCallActions<
    MarketingPerformanceReportItem[]
  >('reporting', 'getMarketingPerformance'),
};
export type ReportingAction = typeof reportingActions;
